<template>
  <div class="col-xl-12 xl-100 col-lg-12 box-col-12">
    <div class="card">
      <div class="card-header">
        <h5><i class="fa fa-users"></i> Lista de Participantes</h5>
        <ul class="nav nav-pills nav-primary float-end" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: showtab === 'app-user' }"
              @click="$emit('changetab', 'app-user')"
            >
              Participantes
            </a>
          </li>
          <!-- <li class="nav-item">
            <a class="nav-link" :class="{ 'active': showtab === 'app-solicitantes' }" @click="$emit('changetab', 'app-solicitantes')">
              Solicitantes
            </a>
          </li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps(["showtab"]);
defineEmits(["changetab"]);
</script>
